import React, { useRef, useState, useEffect, useContext } from "react";
import { useParams } from 'react-router-dom';
import { Row, Col, Button, Tour, Popconfirm } from 'antd';
import { useNavigate } from 'react-router-dom';
import { MyContext } from '../App';
import "../assets/css/designer.css"

// react-pintura
import { PinturaEditor } from "@pqina/react-pintura";
import TShirtBlack from '../assets/images/Designer/TshirtFrontDesignBlack.png';
import TShirtWhite from '../assets/images/Designer/TshirtFrontDesign.png';
import TShirtGrey from '../assets/images/Designer/TshirtFrontGrayDesign.png';
import KidShirtBlack from '../assets/images/Designer/KidDorsFrontBlack.png';
import KidShirtWhite from '../assets/images/Designer/KidDorsFrontWhite.png';
import KidShirtGrey from '../assets/images/Designer/KidDorsFrontGrey.png';
import WomenTShirtBlack from '../assets/images/Designer/WomenTShirtBlackFrontDesign.png';
import WomenTShirtWhite from '../assets/images/Designer/WomenTshirtFrontDesign.png';
import WomenTShirtGrey from '../assets/images/Designer/WomenTShirtGreyFrontDesign.png';
import CropTShirtBlack from '../assets/images/Designer/CropTshirtFrontBlack.png';
import CropTShirtWhite from '../assets/images/Designer/CropTshirtFrontWhite.png';
import CropTShirtGrey from '../assets/images/Designer/CropTshirtFrontGrey.png';
import ShirtBlack from '../assets/images/Designer/MenDorsFrontBlack.png';
import ShirtWhite from '../assets/images/Designer/MenDorsFrontWhite.png';
import ShirtGrey from '../assets/images/Designer/MenDorsFrontGrey.png';
import HoodieBlack from '../assets/images/Designer/MenHoodieBlaackFront.png';
import HoodieWhite from '../assets/images/Designer/MenHoodieWhiteFront.png';
import HoodieGrey from '../assets/images/Designer/MenHoodieGreyFront.png';
import CollarTShirtBlack from '../assets/images/Designer/CollarTshirtBlackFront.png';
import CollarTShirtWhite from '../assets/images/Designer/CollarTshirtFrontWhite.png';
import CollarTShirtGrey from '../assets/images/Designer/CollarTShirtFrontGrey.png';
import WomenCollarTShirtBlack from '../assets/images/Designer/WomenCollarFrontBlack.png';
import WomenCollarTShirtWhite from '../assets/images/Designer/WomanCollarFrontWhite.png';
import WomenCollarTShirtGrey from '../assets/images/Designer/WomenCollarfrontGrey.png';


// pintura
import "@pqina/pintura/pintura.css";
import {
  getEditorDefaults,
  setPlugins,
  plugin_sticker,
  plugin_sticker_locale_en_gb,
  createMarkupEditorShapeStyleControls,
} from "@pqina/pintura";

setPlugins(plugin_sticker);

export default function Designer() {
  const { setFirstDesignBase64, setFirstDesignAdditionalPics } = useContext(MyContext);
  const navigate = useNavigate();
  const { ProductType } = useParams(); // Gets the dynamic ID from the URL  

  // Inline result
  const [designBackGround, setDesignBackGround] = useState(null);
  const [nextDesignURL, setNextDesignURL] = useState(true);
  const [nextStepPopUp, setNextStepPopUp] = useState(false);
  const [result, setResult] = useState("");
  const [uploadedImages, setUploadedImages] = useState([])
  const [designedImageBase64, setDesignedImageBase64] = useState('');


  const editorRef = useRef(null);
  const ExportBtnref = useRef(null);
  const [open, setOpen] = useState(true);
  const steps = [
    {
      title: 'صفحه ی طراحی',
      description: 'در این صفحه می توانید محصول مورد نظر خود را طراحی کنید',
      target: null,
      nextButtonProps: {
        children: (
          <>شروع</>
        ),

      }
    },
    {
      title: 'ابزار طراحی',
      description: 'از ابزار "افزودن عکس" برای اضافه کردن طرح های آماده یا دلخواه خود و از ابزار "افزودن متن" برای اضافه کردن نوشته به محصول استفاده کنید.',
      placement: 'bottom',
      target: () => editorRef.current,
      nextButtonProps: {
        children: (
          <>بعد</>
        ),

      },
      prevButtonProps: {
        children: (
          <>مرحله ی قبل</>
        ),

      }
    },
    {
      title: 'مرحله ی بعد',
      description: 'پس از تکمیل طرح مورد نظر خود، از این دکمه برای ذخیره طرح استفاده کنید',
      placement: 'bottom',
      target: () => ExportBtnref.current,
      prevButtonProps: {
        children: (
          <>مرحله ی قبل</>
        ),
      },
      nextButtonProps: {
        children: (
          <>متوجه شدم</>
        ),

      }
    },
  ];

  useEffect(() => {

    switch (ProductType.split("-")[0]) {

      // MEN 
      case "MenTShirt":


        switch (ProductType.split("-")[1]) {
          case "White":
            setDesignBackGround(TShirtWhite)
            break;
          case "Black":
            setDesignBackGround(TShirtBlack)
            break;
          case "Grey":
            setDesignBackGround(TShirtGrey)
            break;
        }
        break;

      case "MenCollarTShirt":


        switch (ProductType.split("-")[1]) {
          case "White":
            setDesignBackGround(CollarTShirtWhite)
            break;
          case "Black":
            setDesignBackGround(CollarTShirtBlack)
            break;
          case "Grey":
            setDesignBackGround(CollarTShirtGrey)
            break;
        }
        break;

      case "MenShirt":


        switch (ProductType.split("-")[1]) {
          case "White":
            setDesignBackGround(ShirtWhite)
            break;
          case "Black":
            setDesignBackGround(ShirtBlack)
            break;
          case "Grey":
            setDesignBackGround(ShirtGrey)
            break;
        }
        break;

      case "MenHoodie":

        switch (ProductType.split("-")[1]) {
          case "White":
            setDesignBackGround(HoodieWhite)
            break;
          case "Black":
            setDesignBackGround(HoodieBlack)
            break;
          case "Grey":
            setDesignBackGround(HoodieGrey)
            break;
        }
        break;


      // WOMEN

      case "WomenTShirt":


        switch (ProductType.split("-")[1]) {
          case "White":
            setDesignBackGround(WomenTShirtWhite)
            break;
          case "Black":
            setDesignBackGround(WomenTShirtBlack)
            break;
          case "Grey":
            setDesignBackGround(WomenTShirtGrey)
            break;
        }
        break;

      case "WomenCollarTShirt":


        switch (ProductType.split("-")[1]) {
          case "White":
            setDesignBackGround(WomenCollarTShirtWhite)
            break;
          case "Black":
            setDesignBackGround(WomenCollarTShirtBlack)
            break;
          case "Grey":
            setDesignBackGround(WomenCollarTShirtGrey)
            break;
        }
        break;

      case "WomenShirt":


        switch (ProductType.split("-")[1]) {
          case "White":
            setDesignBackGround(ShirtWhite)
            break;
          case "Black":
            setDesignBackGround(ShirtBlack)
            break;
          case "Grey":
            setDesignBackGround(ShirtGrey)
            break;
        }
        break;

      case "WomenHoodie":

        switch (ProductType.split("-")[1]) {
          case "White":
            setDesignBackGround(HoodieWhite)
            break;
          case "Black":
            setDesignBackGround(HoodieBlack)
            break;
          case "Grey":
            setDesignBackGround(HoodieGrey)
            break;
        }
        break;

      case "WomenCropTShirt":

        switch (ProductType.split("-")[1]) {
          case "White":
            setDesignBackGround(CropTShirtWhite)
            break;
          case "Black":
            setDesignBackGround(CropTShirtBlack)
            break;
          case "Grey":
            setDesignBackGround(CropTShirtGrey)
            break;
        }
        break;


      // BOYS 
      case "BoysTShirt":


        switch (ProductType.split("-")[1]) {
          case "White":
            setDesignBackGround(TShirtWhite)
            break;
          case "Black":
            setDesignBackGround(TShirtBlack)
            break;
          case "Grey":
            setDesignBackGround(TShirtGrey)
            break;
        }
        break;

      case "BoysCollarTShirt":


        switch (ProductType.split("-")[1]) {
          case "White":
            setDesignBackGround(CollarTShirtWhite)
            break;
          case "Black":
            setDesignBackGround(CollarTShirtBlack)
            break;
          case "Grey":
            setDesignBackGround(CollarTShirtGrey)
            break;
        }
        break;

      case "BoysShirt":


        switch (ProductType.split("-")[1]) {
          case "White":
            setDesignBackGround(KidShirtWhite)
            break;
          case "Black":
            setDesignBackGround(KidShirtBlack)
            break;
          case "Grey":
            setDesignBackGround(KidShirtGrey)
            break;
        }
        break;

      case "BoysHoodie":


        switch (ProductType.split("-")[1]) {
          case "White":
            setDesignBackGround(HoodieWhite)
            break;
          case "Black":
            setDesignBackGround(HoodieBlack)
            break;
          case "Grey":
            setDesignBackGround(HoodieGrey)
            break;
        }
        break;



      // BOYS 
      case "GirlsTShirt":


        switch (ProductType.split("-")[1]) {
          case "White":
            setDesignBackGround(TShirtWhite)
            break;
          case "Black":
            setDesignBackGround(TShirtBlack)
            break;
          case "Grey":
            setDesignBackGround(TShirtGrey)
            break;
        }
        break;

      case "GirlsCollarTShirt":


        switch (ProductType.split("-")[1]) {
          case "White":
            setDesignBackGround(CollarTShirtWhite)
            break;
          case "Black":
            setDesignBackGround(CollarTShirtBlack)
            break;
          case "Grey":
            setDesignBackGround(CollarTShirtGrey)
            break;
        }
        break;

      case "GirlsShirt":


        switch (ProductType.split("-")[1]) {
          case "White":
            setDesignBackGround(KidShirtWhite)
            break;
          case "Black":
            setDesignBackGround(KidShirtBlack)
            break;
          case "Grey":
            setDesignBackGround(KidShirtGrey)
            break;
        }
        break;

      case "GirlsHoodie":


        switch (ProductType.split("-")[1]) {
          case "White":
            setDesignBackGround(HoodieWhite)
            break;
          case "Black":
            setDesignBackGround(HoodieBlack)
            break;
          case "Grey":
            setDesignBackGround(HoodieGrey)
            break;
        }
        break;

      default:
        setNextDesignURL(false)
        break;


    }

    setInterval(
      () => {
        const spans = document.querySelectorAll("span");

        // Loop through and modify only those with "Sticker"
        spans.forEach((span) => {
          if (span.innerHTML == "Select image") {
            span.innerText = "انتخاب عکس"
          }
          if (span.innerHTML == "Font color") {
            span.innerText = "رنگ فونت"
          }
          if (span.innerHTML == "Font") {
            span.innerText = "فونت"
          }
          if (span.innerHTML == "Font style") {
            span.innerText = "استایل فونت"
          }
          if (span.innerHTML == "Font style") {
            span.innerText = "استایل فونت"
          }
          if (span.innerHTML == "Font size") {
            span.innerText = "اندازه فونت"
          }
          if (span.innerHTML == "Line height") {
            span.innerText = "اندازه سطر"
          }
          switch (span.innerHTML.trim()) {
            case "Sticker":
              span.innerText = "افزودن عکس";
              break;
            case "Annotate":
              span.innerText = "افزودن متن"
              break;
            case "font color":
              span.innerText = "افزودن متن"
              break;
          }
        });
      },
      100
    );

  }, []);

  const handleCaptureAndNextStep = () => {
    setNextStepPopUp(false)
    debugger
    document.getElementById("NextStepPopConfirm").style.display = "none"
    document.getElementsByTagName("nav")[0].style.display = "none"
    document.getElementById("commendation").style.display = "none"
    document.getElementById("pinturaNavButtons").style.display = "none"
    document.getElementsByTagName("footer")[0].style.display = "none"

    window.print();

    document.getElementsByTagName("nav")[0].style.display = "block"
    document.getElementById("commendation").style.display = "block"
    document.getElementById("pinturaNavButtons").style.display = "block"
    document.getElementsByTagName("footer")[0].style.display = "block"

    document.getElementsByClassName("PinturaButtonExport")[0].click()


  };

  const NextStep = () => {
    document.getElementsByClassName("PinturaButtonExport")[0].click()
  };

  const editorDefaults = getEditorDefaults({
    util: "sticker",
    utils: ["sticker", "annotate"],
    locale: {
      ...plugin_sticker_locale_en_gb,
    },

  });

  const handleEditorAddshape = async (shape) => {
    try {
      let base64Image;

      if (shape.backgroundImage && shape.backgroundImage.startsWith("blob:")) {
        const response = await fetch(shape.backgroundImage);
        const blob = await response.blob();

        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
          base64Image = reader.result;
          saveImage(base64Image, shape.id);
        };
      }
      else if (shape.backgroundImage) {
        base64Image = await convertUrlToBase64(shape.backgroundImage);
        saveImage(base64Image, shape.id);
      }

    } catch (error) {
      alert("Error handling shape image");
    }
  };

  const saveImage = (base64, id) => {
    const prevUploadedImages = [...uploadedImages];
    prevUploadedImages.push({
      id: id,
      ImageBase64: base64,
    });
    setUploadedImages(prevUploadedImages);
  };

  const convertUrlToBase64 = (url) => {
    return new Promise((resolve, reject) => {
      fetch(url)
        .then((response) => response.blob())
        .then((blob) => {
          const reader = new FileReader();
          reader.onloadend = () => {
            resolve(reader.result); // Base64 result
          };
          reader.onerror = reject; // Reject on error
          reader.readAsDataURL(blob); // Convert Blob to Base64
        })
        .catch(reject); // Handle fetch errors
    });
  };
  const handleEditorRemoveshape = (shape) => {
    var newUploadedImages = uploadedImages.filter(item => item.id !== shape.id);
    setUploadedImages(newUploadedImages)
  };

  const ReturnBtnConfirm = (e) => {
    navigate("/choose-product");

  };



  return (
    <div style={{ maxWidth: "1000px", margin: "0 auto" }}>

      {/* <Tour open={open} onClose={() => setOpen(false)} steps={steps} /> */}
      <Row align={"center"} >
        <Col id="pinturaNavButtons" style={{ backgroundColor: "white", maxWidth: "1000px", borderRadius: "16px 16px 0 0" }} span={21} >
          <Row className="pb-4">
            <Col span={12}>
              <Popconfirm
                id="ReturnPopConfirm"
                placement="bottom"
                title="هشدار!"
                description="در صورت بازگشت تغییرات اعمال شده ذخیره نخواهد شد"
                onConfirm={ReturnBtnConfirm}
                okText="بازگشت"
                cancelText="لغو"
                zIndex={29}
                okButtonProps={{ style: { width: '160px' } }}   
                cancelButtonProps={{ style: { width: '160px' } }}  

              >
                <Button type="secondary" className="button-100-2">برگشت</Button>
              </Popconfirm>

            </Col>
            <Col span={12}>
              <Popconfirm
                id="NextStepPopConfirm"
                placement="bottom"
                title="تایید"
                description={<p>طراحی دلخواه شما با موفقیت ذخیره گردید.<br /> در صورتی که می خواهید این طراحی را به صورت پی در اف در دستگاه <br /> خود ذخیره کنید، دکمه ی ذخیره PDF و  مرحله ی بعد را انتخاب کنید</p>}
                onConfirm={NextStep}
                onCancel={handleCaptureAndNextStep}
                cancelText="ذخیره PDF و مرحله ی بعد"
                okText="ذخیره و مرحله ی بعد"
                zIndex={29}
                okButtonProps={{ style: { width: '160px' } }}
                cancelButtonProps={{ style: { width: '160px' } }}
              >
                <Button ref={ExportBtnref} type="primary" className="button-100-1">تایید و مرحله ی  بعد</Button>
              </Popconfirm>
            </Col>
          </Row>
        </Col>
        <Col ref={editorRef} id="PintureEditorCanvas" span={21} style={{ height: "850px", maxWidth: "1000px" }}>

          <PinturaEditor
            enableButtonRevert={false}
            {...editorDefaults}

            markupEditorShapeStyleControls={createMarkupEditorShapeStyleControls(
              {
                annotateActiveTool: 'text',
                fontSizeOptions: [10, 20, 30, 45, 60, 75, 95, 105, 130, 155, 185, 215, 250, 290, 350, 450, 600, 850],
                lineHeightOptions: false,
              }
            )}
            onAddshape={handleEditorAddshape}
            onRemoveshape={handleEditorRemoveshape}
            markupEditorToolbar={["text"]}
            annotateActiveTool="text"
            stickers={[
              [
                'بچگانه',

                [
                  "/assets/DesignerPage/Cute/CL1236-14.png",
                  "/assets/DesignerPage/Cute/CL1236-17.png",
                  "/assets/DesignerPage/Cute/CL1237-17.png",
                  "/assets/DesignerPage/Cute/CL1237-19.png",
                  "/assets/DesignerPage/Cute/CL1237-22.png",
                  "/assets/DesignerPage/Cute/CL1241-06.png",
                  "/assets/DesignerPage/Cute/CL1242-10.png",
                  "/assets/DesignerPage/Cute/CL1244-06.png",
                  "/assets/DesignerPage/Cute/CL1244-12.png",
                  "/assets/DesignerPage/Cute/CL1244-14.png",
                  "/assets/DesignerPage/Cute/HAPPY-EASTER-01.png",
                  "/assets/DesignerPage/Cute/HAPPY-EASTER-18.png",

                ],

              ],
              [
                'خرگوش',
                [
                  "/assets/DesignerPage/Rabbit/CL1237-02.png",
                  "/assets/DesignerPage/Rabbit/CL1237-05.png",
                  "/assets/DesignerPage/Rabbit/CL1237-10.png",
                  "/assets/DesignerPage/Rabbit/CL1239-03.png",
                  "/assets/DesignerPage/Rabbit/CL1239-04.png",
                  "/assets/DesignerPage/Rabbit/CL1239-05.png",
                  "/assets/DesignerPage/Rabbit/CL1240-03.png",
                  "/assets/DesignerPage/Rabbit/CL1240-05.png",
                  "/assets/DesignerPage/Rabbit/CL1241-01.png",
                  "/assets/DesignerPage/Rabbit/CL1241-03.png",
                  "/assets/DesignerPage/Rabbit/CL1242-01.png",
                  "/assets/DesignerPage/Rabbit/CL1244-01.png",
                  "/assets/DesignerPage/Rabbit/HAPPY-EASTER-10.png",
                  "/assets/DesignerPage/Rabbit/Untitled-6-04.png",
                ],
              ],
              [
                'جوجه',
                [
                  "/assets/DesignerPage/Chicken/CL1242-03.png",
                  "/assets/DesignerPage/Chicken/CL1244-03.png",
                  "/assets/DesignerPage/Chicken/EASTER-06.png",
                  "/assets/DesignerPage/Chicken/HAPPY-EASTER-14.png",
                ],
                // group properties
                {

                },
              ],
            ]}
            src={designBackGround}
            imageCropAspectRatio={1}
            enableTapToAddText={true}
            onLoad={(res) => {

              console.log("load image", res)
            }}

            onProcess={({ dest }) => {
              const reader = new FileReader();
              reader.readAsDataURL(dest);
              reader.onloadend = () => {
                const base64data = reader.result;
                setDesignedImageBase64(base64data)
                setFirstDesignBase64(base64data)
                setFirstDesignAdditionalPics(uploadedImages)
                if (nextDesignURL) {
                  navigate("/second-designer/" + ProductType);
                }
                else {
                  // navigate("/second-designer/" + ProductType);
                }
              };
            }}
          />

        </Col>
      </Row>
    </div>

  );
}


